// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentInputModel {
    static getAttributeTypeMap() {
        return EnrollmentInputModel.attributeTypeMap;
    }
}
EnrollmentInputModel.discriminator = undefined;
EnrollmentInputModel.additionalProperties = false;
EnrollmentInputModel.attributeTypeMap = [
    {
        "name": "paymentTypeCode",
        "baseName": "paymentTypeCode",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentInputModel.js.map